import * as React from 'react';
import { SVGProps } from 'react';

const SvgSchedule = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M9.6 15.1h3.6v3.6H9.6v-3.6zm5.3 0h3.6v3.6h-3.6v-3.6zm5.4 0h3.6v3.6h-3.6v-3.6zm5.4 0h3.6v3.6h-3.6v-3.6zm-16.1 6h3.6v3.6H9.6v-3.6zm5.3 0h3.6v3.6h-3.6v-3.6zm5.4 0h3.6v3.6h-3.6v-3.6zm-10.7 6h3.6v3.6H9.6v-3.6zm5.3 0h3.6v3.6h-3.6v-3.6zm5.4 0h3.6v3.6h-3.6v-3.6zm5.4-6h3.6v3.6h-3.6v-3.6zm0 6h3.6v3.6h-3.6v-3.6z"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M11.5 9V5m16.8 4V5"
    />
    <path fill="currentColor" d="M5 9.4h28.8v2.9H5V9.4z" />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M33.8 27.1V9.2H5v25.2h25.6"
    />
    <path fill={props.fill} d="M30.6 26.9h4v4.3l-4 4v-8.3z" />
  </svg>
);

export default SvgSchedule;
